import React, { Component } from "react";

const roles = [
  { value: "gp", label: "GP" },
  { value: "gp_trainee", label: "GP Trainee" },
  { value: "consultant", label: "Consultant" },
  { value: "hospital_doctor", label: "NCHD (Hospital Doctor)" },
  { value: "nurse_specialist", label: "Nurse Specialist/ANP" },
  // {},
  { value: "nurse", label: "Nurse" },
  {
    value: "allied_healthcare_professional",
    label: "Allied Healthcare Professional",
  },
  { value: "pharmacist", label: "Pharmacy" },
  // { value: "midwifery", label: "Midwife" },
];

class ApproveDisciplineItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: true,
    };

    this.onDisciplineApproveHandler =
      this.onDisciplineApproveHandler.bind(this);
    this.onDisciplineRejectHandler = this.onDisciplineRejectHandler.bind(this);
  }

  onDisciplineApproveHandler = () => {
    this.props.onDisciplineApprove(this.props.user && this.props.user.id);
    this.setState({ isVisible: false });
  };

  onDisciplineRejectHandler = () => {
    this.props.onDisciplineReject(this.props.user && this.props.user.id);
    this.setState({ isVisible: false });
  };

  render() {
    const {
      id,
      new_user_type,
      // new_disciplines,
      user,
    } = this.props.user;
    const {
      first_name,
      last_name,
      email,
      user_type,
      // disciplines
    } = user;

    const ITEM_HEIGHT = 48;
    const is_checked = _.includes(this.props.user_ids, id);
    const { isVisible } = this.state;

    return isVisible ? (
      <tr>
        <td>
          <p>
            <input
              type="checkbox"
              className="filled-in"
              id="filled-in-box10"
              key={id}
              checked={is_checked}
            />
          </p>
        </td>
        <td>
          {first_name} {last_name}
        </td>
        <td>{email}</td>
        <td>{roles[user_type] ? roles[user_type].label : user_type}</td>
        {/*<td>*/}
        {/*  { disciplines.map(discipline => (discipline.title))}</td>*/}
        <td>
          {roles[new_user_type] ? roles[new_user_type].label : new_user_type}
        </td>
        {/*<td>{new_disciplines.map(discipline => (discipline.title || discipline))}</td>*/}
        <div
          className="submit_center col s12"
          onClick={() => this.onDisciplineApproveHandler()}
        >
          <input
            className="sign"
            type="submit"
            name=""
            value="Approve user type"
          />
        </div>

        <div
          className="submit_center col s12"
          onClick={() => this.onDisciplineRejectHandler()}
        >
          <input className="sign" type="submit" name="" value="Reject" />
        </div>
      </tr>
    ) : (
      <tr></tr>
    );
  }
}

ApproveDisciplineItem.defaultProps = {};

ApproveDisciplineItem.propTypes = {};

export default ApproveDisciplineItem;



// WEBPACK FOOTER //
// ./src/components/Admin/ApproveDiscipline/ApproveDisciplineItem.jsx